import React, { useContext, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Button from '@material-ui/core/Button'
import { split, upperFirst } from 'lodash'

// utils
import { getBaseUrl } from '../utils'

// layout
import Layout from '../layout'

// styles
import { useStyles } from '../styles/common.style'

// store
import { Context } from '../store'
import types from '../store/types'

// API
import { userSignedAgreement } from '../API'

import { t } from 'application-translator/dist/translate/translate.react.js';
import parse from 'html-react-parser'


function OneLastThing() {
  const classes = useStyles()

  // global state
  const { globalState, dispatch } = useContext(Context)
  const { countryCode, agreed, signedBy, signedEmail, phone, clubId } =
    globalState.userData || {}

  // router hooks
  const location = useLocation()
  const history = useHistory()

  // local state
  const [formData, setFormData] = useState({
    accept: false,
    error: false,
  })

  // callbacks
  const handleChange = (event) => {
    setFormData({
      ...formData,
      accept: event.target.checked,
      error: !event.target.checked,
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!formData.accept) {
      setFormData({
        ...formData,
        error: true,
      })
      return
    }

    if (formData.error) return

    callApi()
  }

  // api call...
  const callApi = async () => {
    // show loading
    dispatch({ type: types.SET_LOADING, payload: true })

    const res = await userSignedAgreement({
      phone,
      club_id: clubId,
      clubUserAgreementId: globalState.clubUserAgreementId,
      countryCode,
      agreed,
      signedBy,
      signedEmail,
    })

    // redirect to next page after api call
    // @TODO: use result from api
    const result = res && res.length > 0
    const { pathname } = location
    const baseUrl = getBaseUrl(pathname)

    // hide loading
    dispatch({ type: types.SET_LOADING, payload: false })

    if (result) {
      history.push(`${baseUrl}/success`)
      return
    }

    history.push(`${baseUrl}/sorry`)
  }

  // show agreement
  const showAgreement = (e) => {
    e.preventDefault()
    dispatch({ type: types.TOGGLE_AGGREEMENT })
  }

  return (
    <Layout title={t('One last thing')}>
      <form
        className={classes.content}
        action="#"
        method="POST"
        onSubmit={handleSubmit}
      >
        <p>
          {parse(t('Thanks <strong>{signedBy}</strong>, great to see you.').replace('{signedBy}', upperFirst(split(signedBy, ' ', 1))))}
        </p>
        <p>
          {t('Please read the')} <a onClick={showAgreement} href="/terms-and-conditions">{t('terms and conditions')}</a> {t('and accept them to begin your work out:')}
        </p>
        <FormControlLabel
          control={
            <Checkbox
              checked={formData.accept}
              onChange={handleChange}
              name="accept"
              color="primary"
            />
          }
          label={<p>{t('I accept the terms and conditions')}</p>}
        />
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={!formData.accept}
        >
          {t('Submit')}
        </Button>
      </form>
    </Layout>
  )
}

export default OneLastThing
